import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { AlertBox, SNETButton } from "shared/dist/components";
import PropTypes from "prop-types";

import classes from "./TermsAndConditions.module.css";
import PrivacyTerms from "./PrivacyTerms";
import FormContentCard from "../../../../Components/PageFormComponents/FormContentCard";

const TermsAndConditions = (props) => {
    const { title, formLabel, onAccept, agreed, onChangeAgreed, Content } = props;

    return (
        <FormContentCard title={title}>
            <div className={classes.termsAndConditions}>
                <Content />
            </div>
            <div className={classes.checkboxAndButton}>
                <FormControlLabel
                    control={<Checkbox onChange={onChangeAgreed} color="primary" />}
                    label={formLabel}
                />
                {onAccept && (
                    <SNETButton disabled={!agreed} onClick={onAccept}>
                        accept
                    </SNETButton>
                )}
            </div>
            <AlertBox type={alert.type} message={alert.message} />
        </FormContentCard>
    );
};

TermsAndConditions.protoTypes = {
    title: PropTypes.string,
    formLabel: PropTypes.string,
    onAccept: PropTypes.func,
    agreed: PropTypes.bool,
    onChangeAgreed: PropTypes.func,
    Content: PropTypes.element,
};

TermsAndConditions.defaultProps = {
    Content: PrivacyTerms,
};

export default TermsAndConditions;
